import { Email as EmailIcon } from '@mui/icons-material'
import { Box, Button, Stack, TextField } from '@mui/material'
import { useLogin } from '@refinedev/core'
import { useState } from 'react'

export const EmailLinkForm: React.FC = () => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const { mutate: login } = useLogin()

  const handleEmailSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!email.trim()) return

    setLoading(true)
    try {
      login({ email: email.trim() })
    } finally {
      setLoading(false)
    }
  }

  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const isEnterDomain = (email: string) => {
    return (
      email.toLowerCase().endsWith('@enter.de') || email.toLowerCase().endsWith('@3e-energy.de')
    )
  }

  return (
    <Box component="form" onSubmit={handleEmailSubmit}>
      <Stack spacing={2}>
        <TextField
          type="email"
          label="Email address"
          value={email}
          onChange={e => setEmail(e.target.value)}
          fullWidth
          required
          disabled={loading}
          placeholder="Enter your @enter.de email address"
          error={email.length > 0 && (!isValidEmail(email) || !isEnterDomain(email))}
          helperText={(() => {
            if (email.length > 0 && !isValidEmail(email)) {
              return 'Please enter a valid email address'
            }
            if (email.length > 0 && !isEnterDomain(email)) {
              return 'Only @enter.de email addresses are allowed'
            }
            return ''
          })()}
          variant="outlined"
        />
        <Button
          type="submit"
          variant="contained"
          size="large"
          fullWidth
          disabled={loading || !isValidEmail(email) || !isEnterDomain(email)}
          startIcon={<EmailIcon />}
          sx={{
            backgroundColor: '#1890ff',
            '&:hover': {
              backgroundColor: '#0074d9',
            },
          }}
        >
          {loading ? 'Sending...' : 'Send Login Link'}
        </Button>
      </Stack>
    </Box>
  )
}
